// extracted by mini-css-extract-plugin
export default {"info":"Message__info___MAh07","error":"Message__error___Ne8AA","container":"Message__container___SrYKv"};